import { makeClassName, Section, SectionProps, SectionSubcomponentProps } from "@hex-insights/core";
import styles from "./styles.module.css";

export type TileProps = SectionProps;

export const Tile = ({ className, ...props }: TileProps) => {
	return <Section className={makeClassName(styles["tile"], className)} {...props} />;
};

Tile.Header = function ({ className, ...props }: SectionSubcomponentProps) {
	return <Section.Header className={makeClassName(styles["tile__header"], className)} {...props} />;
};

Tile.Body = function ({ className, ...props }: SectionSubcomponentProps) {
	return <Section.Body className={makeClassName(styles["tile__body"], className)} {...props} />;
};

Tile.Footer = function ({ className, ...props }: SectionSubcomponentProps) {
	return <Section.Footer className={makeClassName(styles["tile__footer"], className)} {...props} />;
};
